import { OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LoginService } from '../services/login.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { BodyOutputType, ToasterService } from 'angular2-toaster';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { Router } from '@angular/router';
var ForgotLoginComponent = /** @class */ (function () {
    function ForgotLoginComponent(router, loginService, bsModalRef, toasterMessageService, toasterService, themeSettingService) {
        this.router = router;
        this.loginService = loginService;
        this.bsModalRef = bsModalRef;
        this.toasterMessageService = toasterMessageService;
        this.toasterService = toasterService;
        this.themeSettingService = themeSettingService;
        this.isEmptyEmail = false;
        this.submitted = false;
        this.isBusy = false;
    }
    ForgotLoginComponent.prototype.ngOnInit = function () {
        this.loaderConfig = this.themeSettingService.getTheme();
    };
    ForgotLoginComponent.prototype.onDecline = function () {
        this.bsModalRef.hide();
    };
    ForgotLoginComponent.prototype.onConfirm = function (email) {
        if (email) {
            this.isEmptyEmail = false;
            if (!this.submitted) {
                this.submitted = true; // prevent form submit called twice
                this.forgotLogin(email);
            }
        }
        else {
            this.isEmptyEmail = true;
        }
    };
    ForgotLoginComponent.prototype.forgotLogin = function (email) {
        var _this = this;
        this.isBusy = true;
        var param = new Array();
        param.push({ name: 'email', value: email });
        this.loginService.forgotLoginDetails(param).subscribe(function (result) {
            _this.handleWorkflowReturn(result);
            _this.isBusy = false;
        }, function (error) {
            _this.isBusy = false;
        });
    };
    ForgotLoginComponent.prototype.handleWorkflowReturn = function (result) {
        var command = JSON.parse(result);
        switch (command.ReturnType) {
            case 0:
                if (command.Arguments) {
                    var path = [];
                    command.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    this.router.navigate(path);
                }
                break;
            case 1:
                this.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
                this.bsModalRef.hide();
                break;
        }
    };
    ForgotLoginComponent.prototype.popToast = function (title, body, type) {
        var _this = this;
        var toast = {
            type: type,
            title: title,
            body: body,
            showCloseButton: true,
            bodyOutputType: BodyOutputType.TrustedHtml,
            onShowCallback: function (toast) {
                var toaster = new Toaster();
                toaster.id = toast.toastId;
                toaster.timestamp = Date.now();
                toaster.title = toast.title;
                toaster.content = toast.body;
                _this.toasterMessageService.pushToaster(toaster);
            }
        };
        this.toasterService.pop(toast);
    };
    return ForgotLoginComponent;
}());
export { ForgotLoginComponent };
